module.exports = __webpack_public_path__ + "img/mob2.1d000f0a.png";